import React, { useEffect, useState } from 'react';
import { Plus, X, Trash2 } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';
import { formatINR, formatDate } from '../lib/format';

const CATS = ['product_kit','travel','tools','marketing','artist_payout','subscriptions','other'];

export default function Expenses() {
  const [items, setItems] = useState([]);
  const [edit, setEdit] = useState(null);
  const load = () => api.get('/expenses').then(r => setItems(r.data.filter(x => !x.deleted_at)));
  useEffect(() => { load(); }, []);
  const save = async (e) => { if (e.id) await api.put(`/expenses/${e.id}`, e); else await api.post('/expenses', e); toast.success('Saved'); setEdit(null); load(); };
  const rm = async (id) => { await api.delete(`/expenses/${id}`); load(); };
  const total = items.reduce((s,e) => s + (e.amount||0), 0);
  return (
    <div className="px-5 py-5 lg:px-10 lg:py-8 max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-5">
        <div><div className="eyebrow">Money</div><h1 className="serif text-[28px]">Expenses</h1><div className="text-sm text-[var(--muted)]">Total {formatINR(total)}</div></div>
        <button className="btn-gold" onClick={() => setEdit({ date: new Date().toISOString().slice(0,10), category: 'product_kit', amount: 0 })} data-testid="expense-add"><Plus size={14}/> Add</button>
      </div>
      <div className="space-y-2">
        {items.length === 0 && <div className="card-cream p-8 text-center text-sm text-[var(--muted)] italic">No expenses yet.</div>}
        {items.map(e => (
          <div key={e.id} className="card-cream p-4 flex items-center justify-between gap-3">
            <div>
              <div className="serif text-[17px]">{e.note || e.category}</div>
              <div className="text-xs text-[var(--muted)] mt-1"><span className="uppercase tracking-[0.14em]">{e.category.replace('_',' ')}</span> · {formatDate(e.date)}{e.gst_claimable?' · GST':''}</div>
            </div>
            <div className="text-right"><div className="serif mono-num">{formatINR(e.amount)}</div>
              <div className="flex gap-2 justify-end mt-1">
                <button onClick={() => setEdit(e)} className="text-xs text-[var(--gold)] tracking-[0.14em] uppercase">Edit</button>
                <button onClick={() => rm(e.id)} className="text-[var(--overdue)]"><Trash2 size={12}/></button>
              </div>
            </div>
          </div>
        ))}
      </div>
      {edit && (
        <div className="fixed inset-0 z-50 flex items-end lg:items-center justify-center bg-black/40 p-0 lg:p-6">
          <div className="w-full max-w-md card-cream p-6 space-y-3">
            <div className="flex items-center justify-between"><h2 className="serif text-[22px]">Expense</h2><button onClick={() => setEdit(null)}><X size={18}/></button></div>
            <div><label className="eyebrow">Date</label><input type="date" value={edit.date} onChange={e => setEdit({...edit, date: e.target.value})}/></div>
            <div><label className="eyebrow">Category</label><select value={edit.category} onChange={e => setEdit({...edit, category: e.target.value})}>{CATS.map(c => <option key={c} value={c}>{c.replace('_',' ')}</option>)}</select></div>
            <div><label className="eyebrow">Amount (₹)</label><input type="number" value={edit.amount} onChange={e => setEdit({...edit, amount: parseFloat(e.target.value||0)})} data-testid="expense-amount"/></div>
            <div><label className="eyebrow">Note</label><input value={edit.note||''} onChange={e => setEdit({...edit, note: e.target.value})}/></div>
            <label className="flex items-center gap-2 text-sm"><input type="checkbox" style={{width:'auto'}} checked={!!edit.gst_claimable} onChange={e => setEdit({...edit, gst_claimable: e.target.checked})}/> GST claimable</label>
            <button className="btn-gold w-full" onClick={() => save(edit)} data-testid="expense-save">Save</button>
          </div>
        </div>
      )}
    </div>
  );
}
